import EditPasswordContainer from './EditPasswordContainer';

export default EditPasswordContainer;
